/**
 * Created by andrey on 11.01.18.
 */

const WebViewSender = function () {
    BaseSender.call(this);

    this.config = {
        maxTimeout: 30
    };
};

WebViewSender.prototype = Object.create(BaseSender.prototype);
WebViewSender.prototype.constructor = WebViewSender;

WebViewSender.prototype.send = function (data, timeout) {
    const id = data.id;
    const code = data.code;

    const title = data.title;
    const message = data.message;
    
    if (!message || !title) {
        connector.notifications.trigger("stream:error", `empty push - ${id
        }\ninfo: ${JSON.stringify(data)}\ndata: ${JSON.stringify(data)
        }\nMessages length: ${Messages}` && Messages.dictionary && Object.keys(Messages.dictionary).length);
        return;
    }

    connector.platform.callNative("LocalPushesPlugin.sendPush", {
        id,
        title,
        message,
        timeout,
        code
    });

    return true;
};

WebViewSender.prototype.cancel = function (info) {
    connector.platform.callNative(
        "LocalPushesPlugin.cancelPush",
        { id: info.id, code: info.code }
    );
};

WebViewSender.prototype.askPermissions = function (options, callback) {
    connector.platform.callNative(
        "LocalPushesPlugin.askPermissions",
        options,
        (code, response) => {
            callback(code, Boolean(response && response.permitted));
        }
    );
};

WebViewSender.isAppropriate = function () {
    return connector.platform.oneOf(connector.AMAZON, connector.ANDROID, connector.DIGITAL, connector.RUSTORE, connector.IOS, connector.MACOS);
};